import React from 'react';
import { Link } from 'react-router-dom';
import xLogo from "../images/xlogo.svg";

const Footer = () => {
  return (
    <footer>
      <div className="w-3/5 mx-auto px-4 sm:px-6 border-t border-b py-3">
        <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between">
          {/* Copyright */}
          <div className="text-[#000000] text-xs text-center">
            ©2025 Match Medic
          </div>

          {/* Terms & Privacy Links */}
          <div className="flex flex-col items-center space-y-1 md:space-y-0 md:flex-row md:space-x-7">
            <Link to="/documents/TermsConditions" className="text-xs text-black hover:underline">
              Terms & Conditions
            </Link>
            <Link to="/documents/PrivacyNotice" className="text-xs text-black hover:underline">
              Privacy Policy
            </Link>
            <Link to="/documents/DataUsage" className="text-xs text-black hover:underline">
              Data Usage
            </Link>
          </div>

          {/* Social Media Links */}
          <div className="flex space-x-3 items-center justify-center">
            <a
              href="https://x.com/usematchmedic"
              target="_blank"
              rel="noopener noreferrer"
              className="flex justify-center items-center text-black transition duration-150 ease-in-out"
              aria-label="xLogo"
            >
              <img src={xLogo} alt="X Logo" className="w-4 h-4" />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61572281754989"
              target="_blank"
              rel="noopener noreferrer"
              className="flex justify-center items-center text-black transition duration-150 ease-in-out"
              aria-label="Facebook"
            >
              <svg
                className="w-9 h-9 fill-current"
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;